import {Component, EventEmitter, Input, Output, QueryList, ViewChild, ViewChildren} from '@angular/core';
import { CommonModule } from '@angular/common';

import {DxButtonModule, DxFormComponent, DxFormModule, DxLoadPanelModule, DxToolbarModule} from "devextreme-angular";
import {DxiItemModule} from "devextreme-angular/ui/nested";
import {FormLabelMode, LabelLocation} from "devextreme/ui/form";
import {Subject} from "rxjs";
import {alert, confirm} from "devextreme/ui/dialog";
import {CtGenLookupComponent} from "../ct-gen-lookup/ct-gen-lookup.component";
import {YilTasima} from "../../models/created.model";
import {DkGlobalUserSettingsService} from "../../services/dk-global-user-settings.service";
import {LookupResTypeEnum} from "../../enums/lookup-expr.enum";
import {OrtakService} from "../../services/ortak.service";
import {ValidationService} from "../../services/validation.service";

@Component({
  selector: 'dk-oku-yaz-yil-tasima',
  standalone: true,
  imports: [CommonModule, CtGenLookupComponent, DxButtonModule, DxToolbarModule, DxiItemModule,
    DxFormModule, CtGenLookupComponent, DxLoadPanelModule,],
  templateUrl: './oku-yaz-yil-tasima.component.html',
  styleUrls: ['./oku-yaz-yil-tasima.component.scss'],
})
export class OkuYazYilTasimaComponent {
  @ViewChild(DxFormComponent, {static: false}) form: DxFormComponent;
  @ViewChildren(CtGenLookupComponent) lookups: QueryList<CtGenLookupComponent>;
  @Output() private submitForm = new EventEmitter<any>();
  @Input() isLoading: boolean = false;
  public tasimaForm: YilTasima = new YilTasima();

  public state: string = 'New';

  labelMode: FormLabelMode = this.golbalSetting.globalLabelMode;
  labelLocation: LabelLocation = this.golbalSetting.globalLabelLocation;

  initialTasimaForm: YilTasima = new YilTasima();
  validationRulesMap: { [key: string]: any[] } = {};
  isFormValid: boolean = false;
  public formChanged = false;
  private destroy$ = new Subject<void>();
  required: any = [{type: "required", message: "Bu alan zorunludur"}]
  protected readonly LookupResTypeEnum = LookupResTypeEnum;

  constructor(public golbalSetting: DkGlobalUserSettingsService,
              public ortakService: OrtakService,
              private validationService: ValidationService,
  ) {
  }

  ngOnInit() {


  }

  ngAfterViewInit() {
    this.validationService.isFormValid(this.form, this.lookups, null);

    this.initialTasimaForm = structuredClone(this.tasimaForm)

  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }


  handleSaveClick(): void {
    if (this.validationService.isFormValid(this.form, this.lookups, null)) {
      this.isLoading = true
      if (this.state === 'New') {
        this.handleTasi();
      }
    } else {
      alert('Lütfen formu uygun şekilde doldurunuz', 'Uyarı');
    }
  }

  handleTasi() {
    this.tasimaForm.piOkunacakYil = Number(this.tasimaForm.piOkunacakYil)
    this.tasimaForm.piYazilacakYil = Number(this.tasimaForm.piYazilacakYil)
    this.submitForm.emit({ value: 'save', data: this.tasimaForm });
  }


  handleCancelClick() {
    this.formChanged = JSON.stringify(this.tasimaForm) !== JSON.stringify(this.initialTasimaForm);
    if (this.formChanged) {
      let confirmSave: boolean
      confirm('Kaydetmediğiniz değişiklikler kaybolacaktır. Devam etmek istiyormusunuz?', 'Uyarı!').then(res => {
        confirmSave = res
        if (confirmSave) {
          this.submitForm.emit({ value: 'close' }); // Popup'ı kapatma
        } else {
        }
      })
    } else {
      this.submitForm.emit({ value: 'close' }); // Popup'ı kapatma
    }
  }



}
